export default __webpack_public_path__ + "static/media/fillPatternSemiBottom.0957177b.svg";